var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "errorReports" } },
    [
      _c("AppBreadCrumb", {
        attrs: { paths: [{ title: _vm.$t("message.feedback") }], select: true },
      }),
      _vm._v(" "),
      _c(
        "b-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("a-table", {
                    staticClass: "custom-table2",
                    attrs: { columns: _vm.cols, dataSource: _vm.errorReports },
                    scopedSlots: _vm._u([
                      {
                        key: "messageSlot",
                        fn: function (report) {
                          return _c("div", { key: report.message }, [
                            _c("div", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    report.message.length > 150
                                      ? report.message.substring(0, 50) + "..."
                                      : report.message
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            report.message.length > 150 ? _c("div") : _vm._e(),
                          ])
                        },
                      },
                      {
                        key: "dateSlot",
                        fn: function (report) {
                          return _c("div", { key: report.date }, [
                            _c("div", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm._f("date")(report.date)) +
                                  "\n                        "
                              ),
                            ]),
                          ])
                        },
                      },
                      {
                        key: "imageUrlSlot",
                        fn: function (report) {
                          return _c("div", {}, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-center align-items-center",
                              },
                              [
                                _c(
                                  "viewer",
                                  {
                                    attrs: {
                                      id: report.imageUrl,
                                      images: [report.imageUrl],
                                    },
                                    on: {
                                      inited: function (viewer) {
                                        return _vm.inited(viewer, report)
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: false,
                                          expression: "false",
                                        },
                                      ],
                                      staticClass:
                                        "img-thumbnail ant-upload-list-picture-card-container",
                                      staticStyle: { "object-fit": "cover" },
                                      attrs: {
                                        id: report.imageUrl,
                                        src: report.imageUrl,
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-button",
                                  {
                                    staticClass:
                                      "actionButton d-flex align-items-center",
                                    on: {
                                      click: function ($event) {
                                        return _vm.show(report._id)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "md-icon",
                                      { staticStyle: { color: "#c9f7f5" } },
                                      [_vm._v("image")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        },
                      },
                      {
                        key: "replied",
                        fn: function (report) {
                          return _c(
                            "div",
                            {
                              key: report._id,
                              staticStyle: { "text-align": "center" },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: report.replied,
                                    expression: "report.replied",
                                  },
                                ],
                                staticClass: "chckbx dealt-with",
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(report.replied)
                                    ? _vm._i(report.replied, null) > -1
                                    : report.replied,
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$a = report.replied,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              report,
                                              "replied",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              report,
                                              "replied",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(report, "replied", $$c)
                                      }
                                    },
                                    function ($event) {
                                      return _vm.CheckBoxChanged(
                                        report,
                                        "replied"
                                      )
                                    },
                                  ],
                                },
                              }),
                            ]
                          )
                        },
                      },
                      {
                        key: "solved",
                        fn: function (report) {
                          return _c(
                            "div",
                            {
                              key: report._id,
                              staticStyle: { "text-align": "center" },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: report.solved,
                                    expression: "report.solved",
                                  },
                                ],
                                staticClass: "chckbx solved",
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(report.solved)
                                    ? _vm._i(report.solved, null) > -1
                                    : report.solved,
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$a = report.solved,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              report,
                                              "solved",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              report,
                                              "solved",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(report, "solved", $$c)
                                      }
                                    },
                                    function ($event) {
                                      return _vm.CheckBoxChanged(
                                        report,
                                        "solved"
                                      )
                                    },
                                  ],
                                },
                              }),
                            ]
                          )
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }